import { featureFlagEnabled } from './featureFlagEnabled';

export const areCloudControllersEnabled = (): boolean => featureFlagEnabled('CLC');
